<template>
	<div>
		<RadioGroup v-model="yesNo" :options="options" @input="onChange"/>
	</div>
</template>

<script>
import RadioGroup from "@/vue/common/form/RadioGroup";
import * as HomeOffice from "@/helper/application/HomeOffice"
import * as Event from "@/helper/tracking/Event";
import EventData from "@/helper/tracking/EventData";

export default {
	components: {
		RadioGroup,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
	},

	data ()
	{
		return {
			yesNo: this.value?.yesNo,
			options: Object.freeze([
				{value: HomeOffice.IRRELEVANT, text: HomeOffice.getLabel(HomeOffice.IRRELEVANT)},
				{value: HomeOffice.YES, text: HomeOffice.getLabel(HomeOffice.YES)},
				{value: HomeOffice.NO, text: HomeOffice.getLabel(HomeOffice.NO)},
			])
		};
	},

	methods: {
		onChange ()
		{
			Event.push(
				new EventData()
					.setEvent(Event.CHARACTERISTIC_SELECTION)
					.setAction('Änderung')
					.setName('Home-Office: ' + HomeOffice.getLabel(this.yesNo))
			);

			this.emitChangeEvent();
		},
		emitChangeEvent ()
		{
			if (this.yesNo === undefined)
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', {
				yesNo: this.yesNo
			})
		}
	}
}
</script>
